import { User } from "types/user";
import { api } from "./api";
import { clearRegistrationUser } from "utils/fns";
import {
  markGenericNotificationRead,
  markReadNotification,
} from "./notification.service";
import queries from "./queries";

const getRealizations = async (player: User, filter?: any): Promise<any> => {
  try {
    if (!player?._id) {
      throw new Error("Player ID is required");
    }

    const clearRegistration = clearRegistrationUser(player._id);

    const body = {
      player: clearRegistration,
      ...filter,
    };

    const { data } = await api.post("/find/realizations", body);
    if (Array.isArray(data)) {
      data.forEach((item) => {
        item.team_data = Array.from(
          new Map(item.team_data.map((team: any) => [team._id, team])).values()
        );
      });
      console.log(data);
      return data;
    }
  } catch (error: any) {
    throw error;
  }
};

const getSubscribedRealizations = async (player: User): Promise<any> => {
  try {
    const clearRegistration = clearRegistrationUser(player._id);

    const { data } = await api.post("/find/listSubscribedRealizations", {
      player: clearRegistration,
    });
    if (!Array.isArray(data)) {
      return null;
    } else {
      return data;
    }
  } catch (error: any) {
    throw error;
  }
};

const newRealization = async (
  body: any,
  realization: any,
  concorrentes: any,
  notificationId?: any
): Promise<any> => {
  try {
    body["id_realizacao"] = realization._id;
    const { data } = await api.post("/database/inscricao__c", body);

    if (!data) {
      throw new Error("Falha ao criar inscrição");
    }

    await newIndication({
      player: body.player,
      id_inscricao: data._id,
      id_realizacao: realization._id,
      dt_aceite: new Date(),
      rawPlayer: body.rawPlayer,
      concorrentes_info: concorrentes,
    });

    if (!!notificationId && notificationId !== "") {
      await markReadNotification(notificationId);
    }

    api.post(
      "/database/insc_partic_premio__c/bulk",
      realization.team_data
        .filter((item: any) => item._id !== body.player)
        .map((item: any) => {
          return {
            player: item._id,
            rawPlayer: item.chave,
            id_inscricao: data._id,
            id_realizacao: realization._id,
            concorrentes_info: [],
          };
        })
    );
  } catch (error: any) {
    console.error("Erro em newRealization:", error.message);
    throw error;
  }
};
// editRealization
const editRealization = async (body: any, concorrentes: any): Promise<any> => {
  try {
    await api.put("/database/inscricao__c", body);

    // await editIndication({
    //     _id:concorrentes._id,
    //     player:body.player,
    //     id_inscricao:body._id,
    //     id_realizacao:body.id_realizacao,
    //     concorrentes_info:concorrentes.itens
    // })
  } catch (error: any) {
    throw error;
  }
};

const newIndication = async (data: any): Promise<any> => {
  try {
    return await api.post("/database/insc_partic_premio__c", data);
  } catch (error: any) {
    throw error;
  }
};

const editIndication = async (
  body: any,
  notificationId?: any
): Promise<any> => {
  try {
    if (!!notificationId && notificationId !== "") {
      await markReadNotification(notificationId);
    } else {
      await markGenericNotificationRead(body);
    }
    return await api.put("/database/insc_partic_premio__c", body);
  } catch (error: any) {
    throw error;
  }
};

const isIndicated = async (itemId: any): Promise<any> => {
  try {
    const query = [
      {
        $match: {
          _id: itemId,
        },
      },
    ];
    const { data } = await api.post(
      "/database/insc_partic_premio__c/aggregate",
      query
    );

    if (!Array.isArray(data)) {
      return null;
    } else {
      return data[0];
    }
  } catch (error: any) {
    throw error;
  }
};

const isSubscribedRealization = async (
  realizationId: any,
  userId: string
): Promise<any> => {
  try {
    const query = [
      {
        $match: {
          $and: [{ id_realizacao: realizationId }, { player: userId }],
        },
      },
    ];

    const { data } = await api.post("database/inscricao__c/aggregate", query);

    if (Array.isArray(data)) {
      return data[0].player ? data[0] : null;
    } else {
      return null;
    }
  } catch (error: any) {
    throw error;
  }
};

const isSubscribed = async (
  realizationId: string,
  player: string
): Promise<any> => {
  try {
    const query = [
      {
        $match: {
          $and: [{ id_realizacao: realizationId }, { player: player }],
        },
      },
    ];

    const { data } = await api.post(
      "database/insc_partic_premio__c/aggregate",
      query
    );

    if (Array.isArray(data)) {
      return data[0].player ? data[0] : null;
    } else {
      return null;
    }
  } catch (error: any) {
    throw error;
  }
};

const countRealizations = async () => {};

const getCategories = async () => {
  try {
    const query = [
      { $match: {} },
      { $group: { _id: "$categoria" } },
      { $sort: { _id: 1 } },
    ];
    const { data } = await api.post(
      "database/task_category__c/aggregate",
      query
    );
    return data;
  } catch (error: any) {
    throw error;
  }
};

const getConfirmedPlayers = async (realizationId: string): Promise<any> => {
  try {
    const query = [
      {
        $match: {
          id_realizacao: realizationId,
          dt_aceite: { $exists: true, $ne: null },
        },
      },
      {
        $group: {
          _id: null,
          confirmados: { $addToSet: "$rawPlayer" },
        },
      },
    ];
    const { data } = await api.post(
      "/database/insc_partic_premio__c/aggregate",
      query
    );

    if (!Array.isArray(data)) {
      return null;
    } else {
      return data[0];
    }
  } catch (error: any) {
    throw error;
  }
};

const getPlayerslist = async (id_realization: string): Promise<any> => {
  try {
    const { data } = await api.post("/find/playersByRealization", {
      id_realizacao: id_realization,
    });
    if (!Array.isArray(data)) {
      return null;
    } else {
      return data[0];
    }
  } catch (error: any) {
    throw error;
  }
};

const onlyWinnersIds = async (): Promise<string[]> => {
  try {
    const { data } = await api.post(
      "/find/listOnlyWinnersRealization",
      {},
      {
        headers: { Range: `items=0-500` },
      }
    );

    if (!Array.isArray(data)) {
      return [];
    }

    return data.flatMap((item) =>
      item.resultado.map((res: any) => res.id_realizacao)
    );
  } catch (error: any) {
    throw error;
  }
};

const getWinners = async () => {
  try {
    const { data } = await api.post(
      "/find/realizationforstep2",
      {},
      {
        headers: {
          Range: `items=0-500`,
          Authorization: `Basic Njc4MDBjODJmYjZjZDc3MjIyNDY5NTg1OjY4OGMzYjVkMjllMzk3NTM1MGE4NWFjMQ==`,
        },
      }
    );

    if (!Array.isArray(data)) {
      return null;
    }

    const categories = Array.from(new Set(data.map((item) => item.categoria)));

    const grouped = categories.map((category) => {
      const realizations = data.filter((item) => item.categoria === category);

      return {
        categoryName: category,
        realizations,
      };
    });

    return grouped;
  } catch (error: any) {
    throw error;
  }
};

const getWinnersPublic = async () => {
  try {
    const { data } = await api.post(
      "/find/realizationforstep2",
      {},
      {
        headers: {
          Range: `items=0-500`,
          //dev
          //Authorization: `Basic Njc4MDBjODJmYjZjZDc3MjIyNDY5NTg1OjY4OGMzYjVkMjllMzk3NTM1MGE4NWFjMQ==`,

          //prod
          Authorization: `Basic Njc5ODU5ODJlNTEwODM1Yzc5NDlmMmE1OjY4OGNlMTgzMjllMzk3NTM1MGE4NjkwMw==`,
        },
      }
    );

    if (!Array.isArray(data)) {
      return null;
    }

    const categories = Array.from(new Set(data.map((item) => item.categoria)));

    const grouped = categories.map((category) => {
      const realizations = data.filter((item) => item.categoria === category);

      return {
        categoryName: category,
        realizations,
      };
    });

    return grouped;
  } catch (error: any) {
    throw error;
  }
};

const getExtrato = async (player: string, playerId: string): Promise<any> => {
  try {
    const { data } = await api.post("/find/extrato", {
      playerId: playerId,
      player: player,
    });
    if (!Array.isArray(data)) {
      return null;
    } else {
      return data;
    }
  } catch (error: any) {
    throw error;
  }
};

const getFinalResult = async (user: User) => {
  try {
    // const { data } = await api.post(
    //   "database/realizacao_avaliacao__c/aggregate",
    //   queries.evaluated_on_step_3
    // );
    const { data } = await api.post(
      "database/resultado_final_premioBB__c/aggregate",
      queries.result_final
    );

    if (!Array.isArray(data)) return null;

    if (data.length > 0) {
      const realizationIds = data.map((item) => item.id_realizacao);
      // const ranking = await indicatedRanking(realizationIds);

      const finalData = data.map((item) => {
        // const currentRanking = ranking.find(
        //   (i) => i.id_realizacao === item.id_realizacao
        // );

        return {
          ...item,
          isMy:
            item.owner === user._id ||
            item.team?.some((t: any) => t._id === user._id) ||
            false,
          // ranking: currentRanking?.concorrentes_info || [],
        };
      });

      const mine = Object.values(
        finalData
          .filter((item) => item.isMy)
          .reduce((acc: Record<string, any>, item) => {
        if (!acc[item.id_realizacao]) {
          acc[item.id_realizacao] = { ...item, group: [item] };
        } else {
          acc[item.id_realizacao].group.push(item);
        }
        return acc;
          }, {})
      );
      const othersRaw = finalData;

      // Agrupar os "others" por categoria
      const categories = Array.from(
        new Set(othersRaw.map((item) => item.categoria))
      );

      const others = categories.map((category) => {
        const realizations = othersRaw
          .filter((item) => item.categoria === category)
          .map((item, index) => ({
            ...item,
            position: item.position,
          }))
          .slice(0, 3);

        return {
          categoryName: category,
          realizations,
        };
      });

      console.log(others);

      return { mine, others };
    }

    return { mine: [], others: [] };
  } catch (error) {
    throw error;
  }
};

const indicatedRanking = async (realizationIds: Array<string>) => {
  try {
    const query = queries.ranking_indicate;

    query.unshift({
      $match: {
        id_realizacao: {
          $in: realizationIds,
        },
      },
    });
    const { data } = await api.post(
      "database/insc_partic_premio__c/aggregate",
      query
    );

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data.map((item) => {
        return {
          concorrentes_info: item.concorrentes_info,
          id_realizacao: item.id_realizacao,
        };
      });
    }
  } catch (error) {
    throw error;
  }
};

export {
  getRealizations,
  getSubscribedRealizations,
  newRealization,
  editRealization,
  newIndication,
  editIndication,
  isSubscribed,
  isIndicated,
  isSubscribedRealization,
  getCategories,
  getConfirmedPlayers,
  getPlayerslist,
  getWinners,
  getExtrato,
  getFinalResult,
  getWinnersPublic,
};
